<template>
  <!-- BEGIN: Footer-->
  <footer class="footer footer-static footer-dark">
    <p class="clearfix mb-0">
      <span class="float-left d-inline-block">2022 © Tüm hakları saklıdır.</span>
      <span class="float-right d-sm-inline-block d-none">
            <a href="https://www.limonist.com/#home" target="_blank" class="text-gray-400 text-hover-primary"><img src="@/assets/images/logo/logo-limonist.png" style="height: 20px" alt=""></a>
        </span>
      <button class="btn btn-primary btn-icon scroll-top" type="button"><i class="bx bx-up-arrow-alt"></i></button>
    </p>
  </footer>
  <!-- END: Footer-->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),
    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  }
};
</script>
